import type { FaireProductEntity } from "../../entity_types/product";

export const p_4rm3amlzbj: FaireProductEntity = {
  token: "p_4rm3amlzbj",
  type: "product",
  name: "BOTANICA",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/83157b32f4ff2646b79fa57da37646875cbee9a633fe8f36a52b3664c187f743.jpeg",
  galleryImageUrls: [],
  priceDollars: 18,
  description: "[ buh-tan-i-kuh ] / a small shop that sells herbs, teas, incense and charms used for healing and spiritual purposes.\n\nThis scent envelopes you with green notes of fresh mint, tomato leaf and sage. Tempered with the subtle presence of herbal tea and a lingering hint of vanilla.\n\nwild mint, sage, white tea, tomato leaf, vanilla\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n7 ounces (198g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:05.140Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
